<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.number"
        placeholder="请输入工位号"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.name"
        placeholder="请输入预约人"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入预约人手机号"
      ></el-input>
      <el-input
        v-if="type == 2"
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入预约公司名称"
      ></el-input>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.status"
        placeholder="请选择预约状态"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="未出租" value="1"></el-option>
        <el-option label="已出租" value="2"></el-option>
      </el-select>
      <el-date-picker
        class="screenInput"
        v-model="screen.start_time"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择预约开始时间"
      >
      </el-date-picker>
      <el-date-picker
        class="screenInput"
        v-model="screen.end_time"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择预约结束时间"
      >
      </el-date-picker>
      <el-button
        type="primary"
        @click="(screen.page = 1), fetchData()"
        style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <div style="margin-top: 10px">
      <el-button
        type="primary"
        @click="addMenu(0)"
        style="margin-bottom: 10px"
        v-if="roles.includes('/station/add')"
        >添加</el-button
      >
    </div>
    <el-tabs v-model="type" type="card" @tab-click="typeHandel">
      <el-tab-pane label="个人工位" name="1">
        <el-table
          max-height="700"
          v-loading="listLoading"
          :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
          :data="list"
          element-loading-text="Loading"
          fit
          highlight-current-row
          stripe
          class="table-box"
          tooltip-effect="dark"
          row-key="id"
        >
          <el-table-column align="center" label="序号" width="95">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>

          <el-table-column label="所属园区" align="center" min-width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.park ? scope.row.park.name : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工位号" align="center" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.number ? scope.row.number : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="80">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status == 1 ? '' : 'success'"
                disable-transitions
              >
                {{ scope.row.status == 1 ? "未出租" : "已出租" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="预约人" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.station_make
                  ? scope.row.station_make.station_make_total.name
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="联系电话" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.station_make ? scope.row.station_make.phone : "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="开始时间" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.station_make
                  ? scope.row.station_make.station_make_total.start_time
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="结束时间" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.station_make
                  ? scope.row.station_make.station_make_total.end_time
                  : "--"
              }}
            </template>
          </el-table-column>
          <!-- <el-table-column label="封面图" width="150" align="center">
              <template slot-scope="scope">
                <el-image
                  v-for="(img, ind) in scope.row.picurl.split(',')"
                  :key="ind"
                  style="width: 120px; height: 40px; margin: 0 5px 5px 0"
                  :src="imageOss + img"
                  fit="contain"
                  :preview-src-list="$pathDispose(scope.row.picurl.split(','))"
                >
                </el-image>
              </template>
            </el-table-column> -->
          <el-table-column
            prop="created_at"
            label="操作"
            width="280"
            fixed="right"
          >
            <template slot-scope="scope">
              <div>
                <el-button
                  size="mini"
                  type="warning"
                  @click="handleInfo(scope.row)"
                  v-if="roles.includes('/station/info')"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  @click="handleEdit(scope.row)"
                  v-if="roles.includes('/station/edit')"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row.id)"
                  v-if="roles.includes('/station/del')"
                  >删除</el-button
                >
              </div>
              <div style="margin-top: 10px">
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleRegister(scope.row, 'add')"
                  v-if="
                    roles.includes('/station_make/register') &&
                    scope.row.status == 1
                  "
                  >预约登记</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleRegister(scope.row, 'edit')"
                  v-if="
                    roles.includes('/station_make/edit_register') &&
                    scope.row.status == 2
                  "
                  >修改预约</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="delRegister(scope.row.station_make.id)"
                  v-if="
                    roles.includes('/station_make/del_register') &&
                    scope.row.status == 2
                  "
                  >解除预约</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="refund(scope.row.station_make.order.id)"
                  v-if="
                    roles.includes('/station_make/refund') &&
                    scope.row.status == 2 &&
                    scope.row.station_make &&
                    scope.row.station_make.source == 2 &&
                    scope.row.station_make.order.order_status == 2 &&
                    +scope.row.price &&
                    scope.row.is_refund == 0
                  "
                  >退款</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- <el-tab-pane label="房间工位" name="2">
        <el-table
          max-height="700"
          v-loading="listLoading"
          :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
          :data="list"
          element-loading-text="Loading"
          fit
          highlight-current-row
          stripe
          class="table-box"
          tooltip-effect="dark"
          row-key="id"
        >
          <el-table-column align="center" label="序号" width="95">
            <template slot-scope="scope">
              {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>

          <el-table-column label="所属园区" align="center" min-width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.park ? scope.row.park.name : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工位号" align="center" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.number ? scope.row.number : "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.status == 1 ? '' : 'success'"
                disable-transitions
              >
                {{ scope.row.status == 1 ? "未出租" : "已出租" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column align="center" label="预约人" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.station_make
                  ? scope.row.station_make.station_make_total.name
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="联系电话" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.station_make ? scope.row.station_make.phone : "--" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="公司名称" min-width="130">
            <template slot-scope="scope">
              {{
                scope.row.station_make
                  ? scope.row.station_make.station_make_total.company_name
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="开始时间" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.station_make
                  ? scope.row.station_make.station_make_total.start_time
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="结束时间" min-width="100">
            <template slot-scope="scope">
              {{
                scope.row.station_make
                  ? scope.row.station_make.station_make_total.end_time
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column label="封面图" width="150" align="center">
              <template slot-scope="scope">
                <el-image
                  v-for="(img, ind) in scope.row.picurl.split(',')"
                  :key="ind"
                  style="width: 120px; height: 40px; margin: 0 5px 5px 0"
                  :src="imageOss + img"
                  fit="contain"
                  :preview-src-list="$pathDispose(scope.row.picurl.split(','))"
                >
                </el-image>
              </template>
            </el-table-column>
          <el-table-column
            prop="created_at"
            label="操作"
            width="280"
            fixed="right"
          >
            <template slot-scope="scope">
              <div>
                <el-button
                  size="mini"
                  type="warning"
                  @click="handleInfo(scope.row)"
                  v-if="roles.includes('/station/info')"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  type="success"
                  @click="handleEdit(scope.row)"
                  v-if="roles.includes('/station/edit')"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row.id)"
                  v-if="roles.includes('/station/del')"
                  >删除</el-button
                >
              </div>
              <div style="margin-top: 10px">
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleRegister(scope.row, 'add')"
                  v-if="
                    roles.includes('/station_make/register') &&
                    scope.row.status == 1
                  "
                  >预约登记</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="handleRegister(scope.row, 'edit')"
                  v-if="
                    roles.includes('/station_make/edit_register') &&
                    scope.row.status == 2
                  "
                  >修改预约</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="delRegister(scope.row.station_make.id)"
                  v-if="
                    roles.includes('/station_make/del_register') &&
                    scope.row.status == 2
                  "
                  >解除预约</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="getRegisterUser(scope.row)"
                  v-if="
                    roles.includes('/station/user_lists') &&
                    scope.row.status == 2
                  "
                  >员工列表</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane> -->
    </el-tabs>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :destroy-on-close="true"
      :before-close="(done) => handleClose(done, 'ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="类型" prop="type">
          <el-radio-group v-model="ruleForm.type" :disabled="cztype == 'see'">
            <el-radio label="1">个人工位</el-radio>
            <el-radio label="2">房间工位</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="工位号" prop="number">
          <el-input
            :disabled="cztype == 'see'"
            class="w4 numInput"
            type="text"
            v-model="ruleForm.number"
            placeholder="请输入工位号"
          ></el-input>
        </el-form-item>
        <template v-if="ruleForm.type == 1">
          <el-form-item label="免费天数" prop="free_day">
            <el-input
              :disabled="cztype == 'see'"
              class="w4 numInput"
              @input="
                ruleForm.free_day = ruleForm.free_day
                  .replace(/[^\d|\.]/g, '')
                  .replace(/^00/g, '0')
                  .replace(/^\./g, '0.')
              "
              type="number"
              v-model="ruleForm.free_day"
              placeholder="请输入免费天数"
              ><template slot="append">天</template></el-input
            >
          </el-form-item>
          <el-form-item label="包月收费价格" prop="price">
            <el-input
              :disabled="cztype == 'see'"
              class="w4 numInput"
              type="number"
              @blur="
                ruleForm.month_price = Number(
                  ruleForm.month_price
                    .replace(/[^\d\.]/g, '')
                    .replace(/^00/g, '0')
                    .replace(/^\./g, '0.')
                ).toFixed(2)
              "
              v-model="ruleForm.month_price"
              placeholder="请输入包月收费价格"
              ><template slot="append">元 / 月</template></el-input
            >
          </el-form-item>
          <el-form-item label="单日收费价格" prop="price">
            <el-input
              :disabled="cztype == 'see'"
              class="w4 numInput"
              type="number"
              @blur="
                ruleForm.price = Number(
                  ruleForm.price
                    .replace(/[^\d\.]/g, '')
                    .replace(/^00/g, '0')
                    .replace(/^\./g, '0.')
                ).toFixed(2)
              "
              v-model="ruleForm.price"
              placeholder="请输入单日收费价格"
              ><template slot="append">元 / 天</template></el-input
            >
          </el-form-item>
        </template>
        <template v-else-if="ruleForm.type == 2">
          <el-form-item label="轮播图" prop="banner">
            <el-upload
              name="file[]"
              :data="{ type: 'image' }"
              class="avatar-uploaders1"
              :action="ossUpload"
              accept=".jpg,.png,.jpeg"
              :headers="{ token: token }"
              list-type="picture-card"
              :show-file-list="true"
              :file-list="thumbFileList"
              :on-remove="handleRemovePic"
              :on-success="handleAvatarSuccess"
              :disabled="cztype == 'see'"
              :class="cztype == 'see' ? 'hide' : ''"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
            ><!-- 已修改 -->
          </el-form-item>
          <el-form-item label="详细介绍" prop="des">
            <Editor
              :disabled="cztype == 'see'"
              ref="myQuillEditor"
              style="width: 100%"
              v-model="ruleForm.des"
            />
          </el-form-item>
        </template>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer
      size="800px"
      :title="registerTitle"
      :visible.sync="registerDrawer"
      direction="rtl"
      :destroy-on-close="true"
      :before-close="(done) => handleClose(done, 'registerForm')"
    >
      <el-form
        :model="registerForm"
        :rules="registeRules"
        ref="registerForm"
        label-width="120px"
      >
        <el-form-item label="预约人" prop="name">
          <el-input
            :disabled="cztype == 'see'"
            class="w4 numInput"
            type="text"
            v-model="registerForm.name"
            placeholder="请输入预约人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            :disabled="cztype == 'see' || cztype == 'edit'"
            class="w4 numInput"
            type="number"
            v-model="registerForm.phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="date_type">
          <el-radio
            v-removeAriaHidden
            :disabled="cztype != 'add'"
            v-model="registerForm.date_type"
            :label="1"
            >天</el-radio
          >
          <el-radio
            v-removeAriaHidden
            :disabled="cztype != 'add'"
            v-model="registerForm.date_type"
            :label="2"
            >月</el-radio
          >
        </el-form-item>
        <template v-if="registerForm.type == 2">
          <el-form-item label="公司名称" prop="company_name">
            <el-input
              :disabled="cztype == 'see'"
              class="w4 numInput"
              type="text"
              v-model="registerForm.company_name"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            :disabled="
              cztype == 'see' ||
              (cztype == 'edit' &&
                new Date(registerForm.start_time).getTime() < currentDate)
            "
            class="w4 numInput"
            v-model="registerForm.start_time"
            :picker-options="pickerOptions"
            placeholder="请输入开始时间"
            type="date"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            :disabled="cztype == 'see'"
            class="w4 numInput"
            v-model="registerForm.end_time"
            :picker-options="pickerOptions"
            placeholder="请输入结束时间"
            type="date"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <div
            class="tip"
            v-if="cztype == 'edit' && registerForm.type == 1 && free_day > 0"
          >
            包含免费天数（{{ free_day }}天）
          </div>
        </el-form-item>

        <template v-if="registerForm.type == 1">
          <el-form-item
            label="租赁单价"
            prop="day_price"
            v-if="registerForm.date_type == 1"
          >
            <el-input
              :disabled="true"
              class="w4 numInput"
              type="number"
              @blur="
                registerForm.day_price = Number(
                  registerForm.day_price
                    .replace(/[^\d|\.]/g, '')
                    .replace(/^00/g, '0')
                    .replace(/^\./g, '0.')
                ).toFixed(2)
              "
              v-model="registerForm.day_price"
              placeholder="请输入租赁单价"
              ><template slot="append">元 / 天</template></el-input
            >
          </el-form-item>
          <el-form-item label="租赁单价" prop="month_price" v-else>
            <el-input
              :disabled="true"
              class="w4 numInput"
              type="number"
              @blur="
                registerForm.month_price = Number(
                  registerForm.month_price
                    .replace(/[^\d|\.]/g, '')
                    .replace(/^00/g, '0')
                    .replace(/^\./g, '0.')
                ).toFixed(2)
              "
              v-model="registerForm.month_price"
              placeholder="请输入租赁单价"
              ><template slot="append">元 / 月</template></el-input
            >
          </el-form-item>
        </template>
        <el-form-item label="租赁费用" prop="price">
          <el-input
            :disabled="cztype == 'see' || registerForm.type == 1"
            class="w4 numInput"
            type="number"
            @blur="
              registerForm.price = Number(
                registerForm.price
                  .replace(/[^\d|\.]/g, '')
                  .replace(/^00/g, '0')
                  .replace(/^\./g, '0.')
              ).toFixed(2)
            "
            v-model="registerForm.price"
            placeholder="请输入租赁费用"
            ><template slot="append">元</template></el-input
          >
        </el-form-item>
        <!-- <template v-if="registerForm.type == 1">
          <el-form-item label="人脸照片" prop="face_url">
            <el-upload
              :limit="1"
              ref="upload"
              name="file[]"
              :data="{ type: 'face' }"
              :action="ossUpload"
              :file-list="faceFileList"
              :headers="{ token: token }"
              list-type="picture-card"
              :on-remove="() => faceHandleRemove('registerForm')"
              :on-success="
                (res, file, fileList) =>
                  faceHandleAvatarSuccess(res, file, fileList, 'registerForm')
              "
              :disabled="cztype == 'see'"
              :before-upload="faceBeforeAvatarUpload"
              accept=".jpg,.png,.jpeg"
              :class="registerForm.face_url ? 'hide' : ''"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="pic-tips">
              人脸照片，后缀只能 jpg，图片尺寸必须大于 256*256 小于 6000*6000
            </div>
          </el-form-item>
        </template> -->

        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('registerForm')"
          >
            确认登记
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('registerForm')"
          >
            修改
          </el-button>
          <el-button type="info" @click="resetForm('registerForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      title="房间用户列表"
      custom-class="userDialog"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div>
        <el-button
          type="primary"
          @click="addUser()"
          style="margin-bottom: 10px"
          v-if="roles.includes('/station/user_add')"
          >添加</el-button
        >
      </div>
      <el-table
        v-loading="userLoading"
        :data="registerUserList"
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        row-key="id"
      >
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{
              (registerUser.page - 1) * registerUser.page_size +
              scope.$index +
              1
            }}
          </template>
        </el-table-column>
        <el-table-column label="姓名" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220px">
          <template slot-scope="scope">
            <div>
              <el-button
                size="mini"
                type="warning"
                @click="handleUserChange(scope.row, 'see')"
                v-if="roles.includes('/station/user_info')"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="handleUserChange(scope.row, 'edit')"
                v-if="roles.includes('/station/user_edit')"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelUser(scope.row.user_id)"
                v-if="roles.includes('/station/user_del')"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-pagination
          :page-size="registerUser.page_size"
          @current-change="registerPageChange"
          layout="prev, pager, next"
          :current-page="registerUser.page"
          :total="registerUser.total"
        >
        </el-pagination>
      </span>
    </el-dialog>
    <el-drawer
      size="800px"
      :title="userTitle"
      :visible.sync="userDrawer"
      direction="rtl"
      :destroy-on-close="true"
      :before-close="(done) => handleClose(done, 'userForm')"
    >
      <el-form
        :model="userForm"
        :rules="registeRules"
        ref="userForm"
        label-width="120px"
      >
        <el-form-item label="预约人" prop="name">
          <el-input
            :disabled="cztype == 'see'"
            class="w4 numInput"
            type="text"
            v-model="userForm.name"
            placeholder="请输入预约人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input
            :disabled="cztype == 'see' || cztype == 'edit'"
            class="w4 numInput"
            type="number"
            v-model="userForm.phone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="人脸照片" prop="face_url">
          <el-upload
            :limit="1"
            ref="upload"
            name="file[]"
            :data="{ type: 'face' }"
            :action="ossUpload"
            :file-list="faceFileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="() => faceHandleRemove('userForm')"
            :on-success="
              (res, file, fileList) =>
                faceHandleAvatarSuccess(res, file, fileList, 'userForm')
            "
            :disabled="cztype == 'see'"
            :before-upload="faceBeforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="userForm.face_url ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="pic-tips">
            人脸照片，后缀只能 jpg，图片尺寸必须大于 256*256 小于 6000*6000
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('userForm')"
          >
            确认添加
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('userForm')"
          >
            修改
          </el-button>
          <el-button type="info" @click="resetForm('userForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { openPark, delImage } from "@/api/index";
import {
  stationReservationList,
  stationReservationAdd,
  stationReservationEdit,
  stationReservationInfo,
  stationReservationDel,
  stationReservationRegister,
  stationReservationEditRegister,
  stationReservationUserList,
  stationReservationDelRegister,
  stationReservationUserAdd,
  stationReservationUserEdit,
  stationReservationUserDel,
  stationReservationRefund,
} from "@/api/sharedOffice";
import { getToken } from "@/utils/auth";
import { getDay } from "@/utils/index";
let currentDate = new Date(new Date().toLocaleDateString()).getTime();
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      type: "1",
      dialogVisible: false,
      userLoading: true,
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        number: "",
        name: "",
        phone: "",
        company_name: "",
        start_time: "",
        end_time: "",
        status: null,
      },
      typeList: [],
      total: 0,
      ruleForm: {
        park_id: "",
        number: "",
        des: "",
        banner: "",
        free_day: "",
        price: "",
        month_price: "",
        type: "1",
      },
      thumbFileList: [],
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        banner: [{ required: true, message: "请选择轮播图" }],
        number: [{ required: true, message: "请输入工位号", trigger: "blur" }],
        des: [
          { required: true, message: "请输入房间工位详情", trigger: "blur" },
        ],
        free_day: [
          { required: true, message: "请输入免费天数", trigger: "blur" },
        ],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
        month_price: [
          { required: true, message: "请输入包月价格", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
      cztype: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      registerUser: {
        park_id: "",
        station_id: "",
        type: "",
        id: "",
        page: 1,
        page_size: 15,
        total: 0,
      },
      registerDrawer: false,
      registerTitle: "登记",
      userTitle: "添加",
      userDrawer: false,
      userForm: {
        park_id: "",
        type: "",
        station_id: "",
        name: "",
        phone: "",
        // face_url: "",
      },
      free_day: 0,
      registerForm: {
        park_id: "",
        type: "",
        station_id: "",
        name: "",
        phone: "",
        // face_url: "",
        price: "",
        company_name: "",
        start_time: "",
        end_time: "",
        day_price: "",
        month_price: "",
        date_type: 1,
      },
      total_day: 0,
      registeRules: {
        face_url: [{ required: true, message: "请选择人脸照片" }],
        name: [{ required: true, message: "请输入预约人", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              var reg = /^1[3456789]\d{9}$/;
              if (!reg.test(value)) {
                callback("请输入正确联系电话");
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        price: [{ required: true, message: "请输入租赁费用", trigger: "blur" }],
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (this.registerForm.end_time && this.registerForm.start_time) {
                var start = new Date(this.registerForm.start_time).getTime();
                var end = new Date(this.registerForm.end_time).getTime();
                if (start > end) {
                  callback("开始时间不能大与结束时间");
                } else {
                  if (this.registerForm.date_type == 1) {
                    var days = getDay(
                      this.registerForm.start_time,
                      this.registerForm.end_time
                    );
                    if (this.registerDrawer && this.cztype == "edit") {
                      var realTime = days - this.free_day;
                      if (realTime <= 0) {
                        callback("租赁天数不能小于免费天数 ");
                      } else {
                        callback();
                      }
                    } else {
                      callback();
                    }
                  } else {
                    var end_time = this.$moment(this.registerForm.end_time);
                    var start_time = this.$moment(
                      this.registerForm.start_time
                    ).add(-1, "days"); // 1
                    var diffMonths = end_time.diff(start_time, "months", true); // 1.75
                    if (diffMonths >= 1) {
                      if (
                        this.registerDrawer &&
                        this.cztype == "edit" &&
                        this.free_day
                      ) {
                        var end_time1 = this.$moment(
                          this.registerForm.end_time
                        ).add(-this.free_day, "days");
                        var start_time1 = this.$moment(
                          this.registerForm.start_time
                        ).add(-1, "days"); // 1
                        var diffMonths1 = end_time1.diff(
                          start_time1,
                          "months",
                          true
                        ); // 1.75
                        if (diffMonths1 < 1) {
                          callback("租赁天数不能小于一个月 ");
                        } else {
                          callback();
                        }
                      } else {
                        callback();
                      }
                    } else {
                      callback("租赁天数不能小于一个月 ");
                    }
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (this.registerForm.end_time && this.registerForm.start_time) {
                var start = new Date(this.registerForm.start_time).getTime();
                var end = new Date(this.registerForm.end_time).getTime();
                if (start > end) {
                  callback("结束时间不能小于开始时间");
                } else {
                  if (this.registerForm.date_type == 1) {
                    var days = getDay(
                      this.registerForm.start_time,
                      this.registerForm.end_time
                    );
                    if (this.registerDrawer && this.cztype == "edit") {
                      var realTime = days - this.free_day;
                      if (realTime <= 0) {
                        callback("租赁天数不能小于免费天数 ");
                      } else {
                        callback();
                      }
                    } else {
                      callback();
                    }
                  } else {
                    var end_time = this.$moment(this.registerForm.end_time);
                    var start_time = this.$moment(
                      this.registerForm.start_time
                    ).add(-1, "days"); // 1
                    var diffMonths = end_time.diff(start_time, "months", true); // 1.75
                    if (diffMonths >= 1) {
                      if (
                        this.registerDrawer &&
                        this.cztype == "edit" &&
                        this.free_day
                      ) {
                        var end_time1 = this.$moment(
                          this.registerForm.end_time
                        ).add(-this.free_day, "days");
                        var start_time1 = this.$moment(
                          this.registerForm.start_time
                        ).add(-1, "days"); // 1
                        var diffMonths1 = end_time1.diff(
                          start_time1,
                          "months",
                          true
                        ); // 1.75
                        if (diffMonths1 < 1) {
                          callback("租赁天数不能小于一个月 ");
                        } else {
                          callback();
                        }
                      } else {
                        callback();
                      }
                    } else {
                      callback("租赁天数不能小于一个月 ");
                    }
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      faceFileList: [],
      registerUserList: [],
      formTypeList: [],
      percentage: 0,
      percentageShow: true,
      clearThumb: [],
      currentDate,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < currentDate;
        },
      },
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  watch: {
    "registerForm.start_time"(val) {
      if (this.registerForm.type == 1 && this.registerForm.date_type == 1) {
        var days = getDay(
          this.registerForm.start_time,
          this.registerForm.end_time
        );
        if (this.registerDrawer && this.cztype == "edit") {
          var realTime = days - this.free_day;
          if (realTime <= 0) {
            this.registerForm.price = "0";
          } else {
            this.registerForm.price = (
              (+this.registerForm.day_price || 0) * realTime
            ).toFixed(2);
          }
        } else {
          this.registerForm.price = (
            (+this.registerForm.day_price || 0) * days
          ).toFixed(2);
        }
      } else if (
        this.registerForm.type == 1 &&
        this.registerForm.date_type == 2
      ) {
        if (this.registerForm.month_price == 0) {
          this.registerForm.price = "0";
          return false;
        }
        if (this.registerForm.start_time && this.registerForm.end_time) {
          if (this.registerDrawer && this.cztype == "edit") {
            if (this.free_day) {
              var end_time = this.$moment(this.registerForm.end_time).add(
                -this.free_day,
                "days"
              );
              var start_time = this.$moment(this.registerForm.start_time).add(
                -1,
                "days"
              ); // 1
              var diffMonths = end_time.diff(start_time, "months", true); // 1.75
              this.registerForm.price = (
                (+this.registerForm.month_price || 0) * diffMonths
              ).toFixed(2);
            } else {
              var end_time = this.$moment(this.registerForm.end_time);
              var start_time = this.$moment(this.registerForm.start_time).add(
                -1,
                "days"
              ); // 1
              var diffMonths = end_time.diff(start_time, "months", true); // 1.75
              this.registerForm.price = (
                (+this.registerForm.month_price || 0) * diffMonths
              ).toFixed(2);
            }
          } else {
            var end_time = this.$moment(this.registerForm.end_time);
            var start_time = this.$moment(this.registerForm.start_time).add(
              -1,
              "days"
            ); // 1
            var diffMonths = end_time.diff(start_time, "months", true); // 1.75
            this.registerForm.price = (
              (+this.registerForm.month_price || 0) * diffMonths
            ).toFixed(2);
          }
        } else {
          this.registerForm.price = "0";
        }
      }
    },
    "registerForm.end_time"(val) {
      if (this.registerForm.type == 1 && this.registerForm.date_type == 1) {
        var days = getDay(
          this.registerForm.start_time,
          this.registerForm.end_time
        );
        if (this.registerDrawer && this.cztype == "edit") {
          var realTime = days - this.free_day;
          if (realTime <= 0) {
            this.registerForm.price = "0";
          } else {
            this.registerForm.price = (
              (+this.registerForm.day_price || 0) * realTime
            ).toFixed(2);
          }
        } else {
          this.registerForm.price = (
            (+this.registerForm.day_price || 0) * days
          ).toFixed(2);
        }
      } else if (
        this.registerForm.type == 1 &&
        this.registerForm.date_type == 2
      ) {
        if (this.registerForm.month_price == 0) {
          this.registerForm.price = "0";
          return false;
        }
        if (this.registerForm.start_time && this.registerForm.end_time) {
          if (this.registerDrawer && this.cztype == "edit") {
            if (this.free_day) {
              var end_time = this.$moment(this.registerForm.end_time).add(
                -this.free_day,
                "days"
              );
              var start_time = this.$moment(this.registerForm.start_time).add(
                -1,
                "days"
              ); // 1
              var diffMonths = end_time.diff(start_time, "months", true); // 1.75
              this.registerForm.price = (
                (+this.registerForm.month_price || 0) * diffMonths
              ).toFixed(2);
            } else {
              var end_time = this.$moment(this.registerForm.end_time);
              var start_time = this.$moment(this.registerForm.start_time).add(
                -1,
                "days"
              ); // 1
              var diffMonths = end_time.diff(start_time, "months", true); // 1.75
              this.registerForm.price = (
                (+this.registerForm.month_price || 0) * diffMonths
              ).toFixed(2);
            }
          } else {
            var end_time = this.$moment(this.registerForm.end_time);
            var start_time = this.$moment(this.registerForm.start_time).add(
              -1,
              "days"
            ); // 1
            var diffMonths = end_time.diff(start_time, "months", true); // 1.75
            this.registerForm.price = (
              (+this.registerForm.month_price || 0) * diffMonths
            ).toFixed(2);
          }
        } else {
          this.registerForm.price = "0";
        }
      }
    },
    "registerForm.date_type"(val) {
      if (this.registerForm.type == 1 && this.registerForm.date_type == 1) {
        if (this.registerForm.day_price == 0) {
          this.registerForm.price = 0;
          return false;
        }
        var days = getDay(
          this.registerForm.start_time,
          this.registerForm.end_time
        );
        if (this.registerDrawer && this.cztype == "edit") {
          var realTime = days - this.free_day;
          if (realTime <= 0) {
            this.registerForm.price = "0";
          } else {
            this.registerForm.price = (
              (+this.registerForm.day_price || 0) * realTime
            ).toFixed(2);
          }
        } else {
          this.registerForm.price = (
            (+this.registerForm.day_price || 0) * days
          ).toFixed(2);
        }
      } else if (
        this.registerForm.type == 1 &&
        this.registerForm.date_type == 2
      ) {
        if (this.registerForm.month_price == 0) {
          this.registerForm.price = 0;
          return false;
        }
        if (this.registerForm.start_time && this.registerForm.end_time) {
          if (this.registerDrawer && this.cztype == "edit") {
            if (this.free_day) {
              var end_time = this.$moment(this.registerForm.end_time).add(
                -this.free_day,
                "days"
              );
              var start_time = this.$moment(this.registerForm.start_time).add(
                -1,
                "days"
              ); // 1
              var diffMonths = end_time.diff(start_time, "months", true); // 1.75
              this.registerForm.price = (
                (+this.registerForm.month_price || 0) * diffMonths
              ).toFixed(2);
            } else {
              var end_time = this.$moment(this.registerForm.end_time);
              var start_time = this.$moment(this.registerForm.start_time).add(
                -1,
                "days"
              ); // 1
              var diffMonths = end_time.diff(start_time, "months", true); // 1.75
              this.registerForm.price = (
                (+this.registerForm.month_price || 0) * diffMonths
              ).toFixed(2);
            }
          } else {
            var end_time = this.$moment(this.registerForm.end_time);
            var start_time = this.$moment(this.registerForm.start_time).add(
              -1,
              "days"
            ); // 1
            var diffMonths = end_time.diff(start_time, "months", true); // 1.75
            this.registerForm.price = (
              (+this.registerForm.month_price || 0) * diffMonths
            ).toFixed(2);
          }
        } else {
          this.registerForm.price = "0";
        }
      }
    },
  },
  methods: {
    refund(order_id) {
      this.$confirm("确认退款？")
        .then(() => {
          stationReservationRefund({ order_id }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
            }
          });
        })
        .catch(() => {});
    },
    // 解除预约
    delRegister(id) {
      this.$confirm("确认解除？")
        .then(() => {
          stationReservationDelRegister({ id }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
            }
          });
        })
        .catch(() => {});
    },
    // 类型切换
    typeHandel() {
      this.screen.page = 1;
      this.screen.total = 0;
      this.list = [];
      this.fetchData();
    },
    handleRemovePic(file, fileList) {
      if (file.response.data.url) {
        this.clearThumb.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm.banner = list.join(",");
    },
    delImges() {
      if (this.clearThumb.length) {
        delImage({ file: this.clearThumb.join(",") }).then((ress) => {});
      }
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        // this.thumbFileList.push({ url: this.imageOss + res.data.url });
        this.ruleForm.banner = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.thumbFileList = list;
      }
    },
    // 人脸识别
    faceHandleAvatarSuccess(res, file, fileList, ref) {
      if (res.code === 200) {
        this[ref].face_url = res.data.url;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.faceFileList = list;
      }
    },
    // 人脸识别删除
    faceHandleRemove(ref) {
      this.faceFileList = [];
      this[ref].face_url = "";
    },
    // 人脸识别上传限制
    faceBeforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
        return false;
      }
      return isLt5M;
    },
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        number: "",
        name: "",
        phone: "",
        company_name: "",
        start_time: "",
        end_time: "",
        status: null,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              if (formName == "ruleForm") {
                stationReservationEdit(that.ruleForm).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                    that.delImges();
                    that.drawer = false;
                    that.fetchData();
                  }
                });
              } else if (formName == "registerForm") {
                const loading = this.$loading({
                  lock: true,
                  text: "修改中...",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                var registerFormData = {};
                if (that.registerForm.date_type == 1) {
                  registerFormData = { ...that.registerForm };
                } else {
                  registerFormData = {
                    ...that.registerForm,
                    day_price: that.registerForm.month_price,
                  };
                }
                stationReservationEditRegister(registerFormData)
                  .then((res) => {
                    loading.close();
                    if (res.code === 200) {
                      this.$message({
                        message: res.msg,
                        type: "success",
                      });
                      that.registerDrawer = false;
                      that.fetchData();
                    }
                  })
                  .catch(() => {
                    loading.close();
                  });
              } else if (formName == "userForm") {
                const loading = this.$loading({
                  lock: true,
                  text: "修改中...",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                stationReservationUserEdit(that.userForm)
                  .then((res) => {
                    loading.close();
                    if (res.code === 200) {
                      this.$message({
                        message: res.msg,
                        type: "success",
                      });
                      that.userDrawer = false;
                      that.getRegisterUser({
                        id: this.registerUser.station_id,
                        type: this.registerUser.type,
                        park_id: this.registerUser.park_id,
                      });
                    }
                  })
                  .catch(() => {
                    loading.close();
                  });
              }
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 房间用户编辑或查看
    handleUserChange(val, type) {
      this.faceFileList = [];
      if (type == "edit") {
        this.cztype = "edit";
        this.userTitle = "编辑";
      } else {
        this.cztype = "see";
        this.userTitle = "查看";
      }

      this.userForm.park_id = val.park_id;
      this.userForm.type = this.registerUser.type;
      this.userForm.station_id = this.registerUser.station_id;
      this.userForm.user_id = val.user_id;
      this.userForm.phone = val.phone;
      this.userForm.name = val.name;
      // this.userForm.face_url = val.face_url;
      // if (this.userForm.face_url) {
      //   this.faceFileList = [
      //     {
      //       name: +new Date(),
      //       url: this.imageOss + this.userForm.face_url,
      //       response: {
      //         data: {
      //           url: this.userForm.face_url,
      //         },
      //       },
      //     },
      //   ];
      // }
      this.userDrawer = true;
    },
    // 房间用户删除
    handleDelUser(id) {
      this.$confirm("确认删除？")
        .then(() => {
          stationReservationUserDel({
            user_id: id,
            station_id: this.registerUser.station_id,
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            this.getRegisterUser({
              id: this.registerUser.station_id,
              type: this.registerUser.type,
              park_id: this.registerUser.park_id,
            });
          });
        })
        .catch(() => {});
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      this.thumbFileList = [];
      this.clearThumb = [];
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleInfo(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.thumbFileList = [];
      this.clearThumb = [];
      this.getInfo(val.id);
    },
    // 工位注册登记
    handleRegister(res, type) {
      this.faceFileList = [];
      this.registerForm = {
        park_id: res.park_id,
        station_id: res.id,
        type: res.type,
        day_price: res.price || "0",
        month_price: res.month_price || "0",
        name: "",
        phone: "",
        // face_url: "",
        price: "0",
        company_name: "",
        start_time: "",
        end_time: "",
        date_type: 1,
      };
      this.free_day = res.free_day;
      if (type == "add") {
        this.cztype = "add";
        this.registerTitle = "预约登记";
      } else {
        this.cztype = "edit";
        this.registerForm.id = res.station_make.id;
        this.registerForm.name = res.station_make.name;
        this.registerForm.phone = res.station_make.phone;
        this.registerForm.company_name = res.station_make.company_name;
        this.registerForm.start_time =
          res.station_make.station_make_total.start_time;
        this.registerForm.end_time =
          res.station_make.station_make_total.end_time;
        this.registerForm.price = res.station_make.station_make_total.price;
        this.registerForm.date_type =
          res.station_make.station_make_total.date_type;
        // this.registerForm.face_url = res.station_make.user_face?res.station_make.user_face.image:"";
        this.registerTitle = "修改登记";
        // if (this.registerForm.face_url) {
        //   this.faceFileList = [
        //     {
        //       name: +new Date(),
        //       url: this.imageOss + this.registerForm.face_url,
        //       response: {
        //         data: {
        //           url: this.registerForm.face_url,
        //         },
        //       },
        //     },
        //   ];
        // }
      }
      this.registerDrawer = true;
    },
    registerPageChange(current) {
      this.registerUser.page = current;
      this.getRegisteredList();
    },
    getRegisterUser(res) {
      this.registerUser = {
        station_id: res.id,
        park_id: res.park_id,
        type: res.type,
        page: 1,
        page_size: 15,
        total: 0,
      };
      this.userLoading = true;
      this.getRegisteredList();
    },
    addUser() {
      this.userTitle = "添加";
      this.cztype = "add";
      this.faceFileList = [];
      this.userForm.station_id = this.registerUser.station_id;
      this.userForm.park_id = this.registerUser.park_id;
      this.userForm.type = this.registerUser.type;
      this.userForm.name = "";
      this.userForm.phone = "";
      this.userForm.user_id = "";
      this.userDrawer = true;
    },
    getRegisteredList() {
      stationReservationUserList(this.registerUser).then((res) => {
        this.userLoading = false;
        this.dialogVisible = true;
        this.registerUserList = res.data.lists.data;
        this.registerUser.page = res.data.lists.current_page;
        this.registerUser.total = res.data.lists.total;
      });
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      stationReservationInfo({ id: id }).then((res) => {
        that.ruleForm = {
          id: res.data.info.id,
          park_id: Number(res.data.info.park_id),
          des: res.data.info.des,
          free_day: res.data.info.free_day,
          price: res.data.info.price,
          number: res.data.info.number,
          month_price: res.data.info.month_price || "0",
          banner: res.data.info.banner ? res.data.info.banner.join(",") : "",
          type: res.data.info.type + "",
        };
        if (res.data.info.banner) {
          this.thumbFileList = res.data.info.banner.map((item) => {
            return {
              name: +new Date(),
              url: this.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
      });
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          stationReservationDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              if (formName == "ruleForm") {
                stationReservationAdd(that.ruleForm).then((res) => {
                  if (res.code === 200) {
                    this.$message({
                      message: res.msg,
                      type: "success",
                    });
                    that.delImges();
                    that.resetForm("ruleForm");
                    that.fetchData();
                  }
                });
              } else if (formName == "registerForm") {
                const loading = this.$loading({
                  lock: true,
                  text: "登记中...",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                var registerFormData = {};
                if (that.registerForm.date_type == 1) {
                  registerFormData = { ...that.registerForm };
                } else {
                  registerFormData = {
                    ...that.registerForm,
                    day_price: that.registerForm.month_price,
                  };
                }
                stationReservationRegister(registerFormData)
                  .then((res) => {
                    loading.close();
                    if (res.code === 200) {
                      this.$message({
                        message: res.msg,
                        type: "success",
                      });
                      that.resetForm("registerForm");
                      that.fetchData();
                    }
                  })
                  .catch(() => {
                    loading.close();
                  });
              } else if (formName == "userForm") {
                const loading = this.$loading({
                  lock: true,
                  text: "添加中...",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)",
                });
                stationReservationUserAdd(that.userForm)
                  .then((res) => {
                    loading.close();
                    if (res.code === 200) {
                      this.$message({
                        message: res.msg,
                        type: "success",
                      });
                      that.resetForm("userForm");
                      that.getRegisterUser({
                        id: this.registerUser.station_id,
                        type: this.registerUser.type,
                        park_id: this.registerUser.park_id,
                      });
                    }
                  })
                  .catch(() => {
                    loading.close();
                  });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done, refName) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs[refName].clearValidate();
            this.$refs[refName].resetFields();
            done();
          });
        })
        .catch(() => {});
    },
    addMenu() {
      this.drawerTitle = "添加";
      this.cztype = "add";
      this.ruleForm = {
        park_id: "",
        number: "",
        des: "",
        banner: "",
        free_day: "",
        price: "0",
        type: this.type,
      };
      this.thumbFileList = [];
      this.clearThumb = [];
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.drawer = false;
      this.registerDrawer = false;
      this.userDrawer = false;
    },
    fetchData() {
      this.listLoading = true;
      stationReservationList({ ...this.screen, type: this.type }).then(
        (response) => {
          this.list = response.data.lists.data;
          this.total = response.data.lists.total;
          this.listLoading = false;
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.tip {
  box-sizing: border-box;
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  // background-color: #fdf6ec;
  font-size: 13px;
  color: #e6a23c;
}
::v-deep .userDialog .el-dialog__body {
  padding-top: 10px;
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px 10px 0;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}

.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}

.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.tabBox {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
